var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAppointment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_602_4422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_602_4422)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E2248"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_602_4422",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_602_4422",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppointment);
export default __webpack_public_path__ + "static/media/icon_appointment.c8dc7009f8e24d4af9dc6fcf8296d05e.svg";
export { ForwardRef as ReactComponent };